import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {DatepickerComponent, CustomNgbDateParserFormatter} from './datepicker.component';
import {TextMaskModule} from 'angular2-text-mask';
import {CommonModule} from '@angular/common';
import {NgbModule, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {ClickOutsideModule} from '../../../events/click-outside/click-outside.module';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [CommonModule, FormsModule, TextMaskModule, NgbModule, ClickOutsideModule],
    providers: [{provide: NgbDateParserFormatter, useClass: CustomNgbDateParserFormatter}],
    declarations: [DatepickerComponent],
    exports: [DatepickerComponent],
})
export class DatepickerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/datepicker/datepicker.module.ts